module.exports = __webpack_public_path__ + "img/card-r09.b2580040.jpg";